import { CCanvas } from './ccanvas';
import { CImage } from './cimage';
import { GLFX, GLFXCanvas } from './filter.contants';
import { ImageContainer } from './image-container';

export declare var fx: GLFX;
declare var UTIF;

export class Photo {
    /**
     * Untainted original image
     */
    private orig_image: HTMLImageElement = undefined;
    get originalImageWidth(){
        return this.getPersistedCanvas().width ?? -1;
    }
    get originalImageHeight(){
        return this.getPersistedCanvas().height ?? -1;
    }
    /**
     * Downscaled image on current state
     * Has all the rotate, resize, crop, flip and filters applies
     */
    private X: HTMLImageElement = null;
    /**
     * image that has rotate, resize, crop, flip and filter. This is
     * the persisted image between tabs
     */
    private Y: HTMLImageElement = null;

    private XCanvas: HTMLCanvasElement = document.createElement('canvas');
    private YCanvas: HTMLCanvasElement = document.createElement('canvas');

    container: ImageContainer;
    carmanCanvas: GLFXCanvas;

    constructor(cssClasses: { x: string, y: string }) {
        this.X = new Image();
        this.Y = new Image();
        this.X.classList.add('img');
        this.XCanvas.classList.add('canvas', 'x', cssClasses.x);
        this.YCanvas.classList.add('canvas', 'y', cssClasses.y);
    }

    async load(file: File, container: ImageContainer): Promise<void> {
        if (!file) {
            console.error('No file were selected');
            throw new Error('No file were selected');
        }
        try {
            document.getElementById('x').remove();
        } catch (e) {
            // suppressed
        }

        try {
            document.getElementById('y').remove();
        } catch (e) {
            // suppressed
        }

        this.container = container;
        if (file.name.match(/\.webp$/i)) {
            await CImage.loadCanvasWithWebPImage(file, this.YCanvas);
            await CImage.loadCanvasWithWebPImage(file, this.XCanvas);
        } else if (file.name.match(/\.tiff$/i) || file.name.match(/\.tif$/i)) {
            await CImage.loadCanvasWithTiffImage(file, this.YCanvas);
            await CImage.loadCanvasWithTiffImage(file, this.XCanvas);
        } else {
            const image = await new Promise<HTMLImageElement>((resolve, reject) => {
                let fileReader = new FileReader();
                fileReader.onload = (evt: any) => {
                    let image = document.createElement('img');
                    let fileDataUrl = evt.target.result;
                    image.onload = () => {
                        // How heade and Remove upload button
                        // Resize the image to managable size
                        resolve(image);
                    };
                    image.setAttribute('src', fileDataUrl);
                };
                fileReader.readAsDataURL(file);
            });
            CCanvas.drawImage(this.YCanvas, image);
            CCanvas.drawImage(this.XCanvas, image);
        }

        this.container.getElement().appendChild(this.XCanvas);
        this.container.getElement().appendChild(this.YCanvas);
        this.XCanvas.id = 'x';
        this.YCanvas.id = 'y';
        this.XCanvas.classList.add('x');
        this.YCanvas.classList.add('y');
        this.initCarmanCanvas();
    }

    public getPersistedImage() {
        return this.Y;
    }

    public getPersistedCanvas() {
        return this.YCanvas;
    }

    public getEphemeralImage() {
        return this.X;
    }

    public getEphemeralCanvas() {
        return this.XCanvas;
    }

    public getCarmanCanvas() {
        return this.carmanCanvas;
    }

    private initCarmanCanvas() {
        const fxCanvas = this.container.getElement().querySelector<GLFXCanvas>('#carman');
        try {
            if (!fxCanvas) {
                this.carmanCanvas = fx.canvas();
                this.carmanCanvas.id = 'carman';
                this.container.getElement().prepend(this.carmanCanvas);
            } else {
                this.carmanCanvas = fxCanvas;
            }

            let targetRect = CImage.getRelativeNearestIntegerHeightFor(this.getPersistedCanvas(), 1000);
            this.carmanCanvas.width = targetRect.width;
            this.carmanCanvas.height = targetRect.height;
            this.carmanCanvas.style.display = 'none';
        } catch (e) {
            console.error(e);
        }
    }
}
